import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { checkForUserLimit } from "../../utils";
import { USER_LIMITS } from "../../utils/constants";
import { getOfflineData } from "../../utils/offline-services";
import { toast } from "react-toastify";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const { limits } = getOfflineData("user");
  const handleDelete = () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address");
      return;
    }
    setError("");
    if (checkForUserLimit(USER_LIMITS.ADMIN, limits)) {
      invokeApi(HTTP_METHODS.DELETE, `${HOSTNAME}${REST_URLS.DELETE_SE}`, {
        email: email,
      })
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Deleted Successfully");
            setEmail("");
            setError("");
          }
        })
        .catch((err) => console.error(err));
    } else {
      toast.error("Only Admin can delete user");
    }
  };

  return (
    <Box className="forgot-pass-con">
      <div className="content-con">
        <Typography variant="h5" gutterBottom>
          Delete Account
        </Typography>

        <Typography variant="body1" color="error" gutterBottom>
          User data will be deleted within 2 hours.
        </Typography>

        <TextField
          fullWidth
          label="Email Address"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={!!error}
          required
          helperText={error}
        />

        <Button
          variant="contained"
          color="error"
          fullWidth
          onClick={handleDelete}
          sx={{ mt: 2 }}
        >
          Submit
        </Button>
      </div>
    </Box>
  );
};

export default DeleteAccount;
